import { ShellLayout, SkeletonLoader } from 'cdk-radial';
import { SKELETON_LOADER_FOOTER, FOOTER_CARD } from './constants';
import { StyledDiv } from './styled';
import { LoaderStyle } from './types';
import type { FC } from 'react';

export const SkeletonFooter: FC = () => (
  <ShellLayout data-testid="Shell-layout-container-3">
    <StyledDiv variant={FOOTER_CARD}>
      {Array.from(Array(3).keys()).map(v => (
        <SkeletonLoader
          key={v}
          height={LoaderStyle.height}
          style={SKELETON_LOADER_FOOTER}
        />
      ))}
    </StyledDiv>
  </ShellLayout>
);
